window.addEventListener('scroll', function () {
    var topButton = document.getElementById('topButton');
    if (window.pageYOffset > 100) {
        topButton.style.display = 'block';
    } else {
        topButton.style.display = 'none';
    }
});

document.getElementById('topButton').addEventListener('click', function () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
